import React from 'react';
import { Row, Col } from 'react-bootstrap';

import Select from 'react-select';

import statuses from 'data/last_member_program_statuses';

export default function Filters({ keyword, setKeyword, setStatus }) {
  return (
    <div className="invite_search">
      <Row>
        <Col md={6}>
          <form className="inviteSearch_form">
            <input
              type="text"
              placeholder="Search by Name"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </form>
        </Col>
        <Col md={6}>
          <Select
            isClearable
            isSearchable
            placeholder="Filter by Program Status"
            onChange={(option) => {
              setStatus(option == null ? null : option.value);
            }}
            options={statuses}
          />

        </Col>
      </Row>
    </div>
  );
}
